export default function addSpaces(str) {
  return str.replace(/(.{4})/g, "$1 ");
}
